<script setup lang='ts'>
    import { FrontpageItemGroup } from '@/shared/helpers/api';
    import FrontpageGroup from './FrontpageGroup.vue';
    import LinkBox from './LinkBox.vue';

    const group1: FrontpageItemGroup = {
        class: 'fpig-2',
        label: '',
        items: [
            { label: 'All libraries', icon: 'bookshelf', href: '/Library' },
            { label: 'SQL query editor', icon: 'database-search', href: '/Sql' },
            { label: 'All library releases', icon: 'crane', href: '/Release' },
            { label: 'Excel import', icon: 'file-excel-outline', href: '/CodeSetImport' },
            { label: 'Library shipping', icon: 'sail-boat', href: '/Shipping' }
        ]
    };

    const group2: FrontpageItemGroup = {
        class: 'fpig-2',
        label: '',
        items: [
            { label: 'Documentation browser', icon: 'file-document-multiple-outline', href: '/Documentation' },
            { label: 'File attachment search', icon: 'file-search-outline', href: '/Config/AttachmentSearch' },
            { label: 'Usage statistics', icon: 'chart-areaspline', href: '/Report/Stats' },
            { label: 'Technical changelog', icon: 'bullhorn-outline', href: '/ChangeLog' },
            { label: 'Technical documentation', icon: 'file-lock-outline', href: window.config!.technicalDocUrl }
        ]
    };
</script>

<template>
    <div class="cell is-child notification is-secondary">
        <div class="title">
            <b-image
                src="/images/Original Logo Full.svg" />
        </div>
        <div class="content">
            <p>
                <b>Common Library</b> is the home of reference data! It's the database that defines the
                set of permissible values to be used by data fields
                in many systems within Equinor.
            </p>
            <div class="columns">
                <div class="column">
                    <frontpage-group :group="group1" />
                </div>
                <div class="column">
                    <frontpage-group :group="group2" />
                </div>
            </div>
            <div class="is-flex is-flex-direction-column is-align-items-center">
                <link-box
                    image="/images/Viva Engage.svg"
                    text="CommonLibrary Viva Engage"
                    href="https://engage.cloud.microsoft/main/org/equinor.com/groups/eyJfdHlwZSI6Ikdyb3VwIiwiaWQiOiIyMTg3OTYyMjg2MDgifQ/all" />
                <link-box
                    image="/images/snow.png"
                    text="Report an error in ServiceNow"
                    href="https://equinor.service-now.com/selfservice?id=sc_cat_item&table=sc_cat_item&sys_id=04465efb1b64b51409a02fc3b24bcbc9" />
            </div>
        </div>
    </div>
</template>

<style scoped>
.cell {
    width: 40rem;
}
</style>
